query AutomationNodeActiveCount($id: ID!, $nodeId: String!) {
  automationNodeActiveCount(id: $id, nodeId: $nodeId)
}
